import * as _ from 'lodash'
import {
    IBusinessObject,
    IBusinessObjectChanges,
    IBusinessObjectChangesOptions,
    IBusinessObjectCreateLoadOptions
} from "../PA.Core/PA.Core.IF.BO";
import { IEntitySource, IMessageProvider, IProgressProvider, MessageType } from "../PA.Core/PA.Core.IF.Basic";
import { PAdbContext } from '../PA.Core/PAdbContext';
import { IdentityProvider } from '../PA.Core/Basic/Identity'
import { MessageProvider } from '../PA.Core/Basic/Messages'
import { ProgressProvider } from '../PA.Core/Basic/Progress'
import {
    WB_CustomerRow,
    WB_FinishedProductRow,
    WB_ModelEventTypeRelationshipRow,
    WB_PeriodRow,
    WB_ProductGroupRow,
    WB_ScenarioPlanCustomerRow,
    WB_ScenarioPlanEventTypeRow,
    WB_ScenarioPlanInputRow,
    WB_ScenarioPlanPredictorRow,
    WB_ScenarioPlanProductRow,
    WB_ScenarioPlanRow,
    WB_SimulationInputRow,
    WB_SpendFunctionRelationshipRow,
    WB_SpendFunctionRelationshipScopeRow,
    WB_SpendFunctionRow
} from "../PA.Core/PAdbSchemaRows";
import { IwbScenarioPlan } from "../PA.Core/PAdbSchemaRowsIF";
import {
    esWB_Customer,
    esWB_Customer_Hierarchy,
    esWB_Entity,
    esWB_Finished_Product,
    esWB_MasterData_Set,
    esWB_Model,
    esWB_Model_Event_Type_Relationship,
    esWB_Period,
    esWB_Period_Hierarchy,
    esWB_Product_Group,
    esWB_Product_Hierarchy,
    esWB_Published_Model,
    esWB_SalesOrg,
    esWB_ScnPlan,
    esWB_ScnPlan_CoeffR,
    esWB_ScnPlan_CustR,
    esWB_ScnPlan_EvtTypeR,
    esWB_ScnPlan_InputR,
    esWB_ScnPlan_PrdR,
    esWB_ScnPlan_PredictorR,
    esWB_Simulation_Input,
    esWB_Simulation_Metrics,
    esWB_Simulation_Metrics_CBO_Set,
    esWB_Simulation_Relationship,
    esWB_Spend_Function,
    esWB_Spend_Function_Relationship,
    esWB_Spend_Function_Relationship_Scope
} from "../PA.Core/PAdbSchema";
import { ESRecord } from "../PA.Core/lib/ESRecord";
import { ESDataStore } from "../PA.Core/lib/ESDataStore";
import { CreateOptions, ESRecordResolver } from "../PA.Core/lib/ESRecordResolver";
import { ASync } from "../PA.Core/Basic/ASync";

import { PAEnvironment } from "../PA.Core/PAEnvironment";
import { DefaultChanges } from "../PA.Core/BusinessObject/BusinessObjectChanges";
import { BehaviorSubject, Subscription } from "rxjs";
import { CoefficientSetUtils, ICoefficientSetSubModel } from "../PA.Model.Core/CoefficientSetUtils";
import { EntityTypeUtils } from "../PA.MD.Entity/EntityTypeUtils";
import { CubeSource } from "../PA.HyperRectangle.Core/CubeSource";
import { ExecutionSerializer } from "../PA.Core/Basic/ExecutionSerializer";
import { DimensionType } from "../PA.Core/PA.Core.IF.Hierarchy";
import { ICubePerspectiveOptions, ICubeSource } from "../PA.HyperRectangle.Core/PA.HyperRectangle.IF";
import { DataSourceJSData } from "../PA.HyperRectangle.Core/DataSourceJSData";
import * as AsyncLock from "async-lock";
import { PASearch } from "../PA.Core/PASearch";
import { DateUtils } from "../PA.Core/Basic/Dates";
import { IPolicyCollection } from "../PA.Core/PA.Core.IF.Policy";
import { IHaveSecurity } from "../PA.Core/PA.Core.IF.Aspects";
import { PolicyHasRole } from "../PA.Core/Security/PolicyHasRole";
import { PolicyBOis } from "../PA.Core/Security/PolicyBOis";
import { PolicyCollection } from "../PA.Core/Security/PolicyCollection"
import { IHaveSimulationFunctions } from "../PA.Simulation.Core/PA.FinancialModel.IF";
import { SpendFunctionUtils } from "../PA.Simulation.Services/SpendFunctionUtils";
import { IScenarioPlanCalculator } from "../PA.Simulation.Services/SimulationServices.IF";
import { ScenarioPlanCalculator } from "../PA.Simulation.Services/ScenarioPlanCalculator";
import { ModelUtils } from '../PA.Model.Services/ModelUtils';
import { SimulationPolicyUtils } from "../PA.Simulation.Services/SimulationPolicyUtils";
import {
    ISimulationExecuteInputOperation,
    ISimulationExecutePredictorOperation,
    ISimulationLoadInputOperation,
    ISimulationLoadInputOperations,
    ISimulationLoadPredictorOperation,
    ISimulationLoadPredictorOperations
} from "../PA.Simulation.Core/PA.Simulation.IF.Aspects";
import { ErrorMessage_restate } from "../PA.Core/Basic/MessageUtils";
import { ModelDataSetService } from "../PA.Model.Services/ModelDataSetService";
import { DimensionPlacement } from "../PA.Reporting.Core/PA.Reporting.IF";

const arrSIMULATION_INPUT_IDs = ['GROSSLISTPRICE', 'LISTPRICE', 'VCM', 'COGS']
const arrSIMULATION_INPUT_TYPE_IDs = ['GrossListPrice', 'ListPrice', 'VCM', 'COGS']
const sleep = (ms: number) =>
    new Promise(resolve => setTimeout(resolve, ms));

export interface IScenarioPlanCopyOptions {
    wbCustIds?: number[],
    wbPrdGrpIds?: number[],
    startDt?: Date,
    endDt?: Date,
    bSkipSpendFunctions?: boolean
    bSkipShipmentFunctions?: boolean,
    bEventMode?: boolean
}

export class ScenarioPlanBO
    implements
        IBusinessObject,
        IHaveSimulationFunctions,
        ISimulationExecuteInputOperation,
        ISimulationExecutePredictorOperation
{
    Identity: IdentityProvider;

    CreateOptions: any;

    LoadOptions: IBusinessObjectCreateLoadOptions;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drWB_ScenarioPlan: WB_ScenarioPlanRow;


    constructor(options?: any) {

        this.CreateOptions = options || {};

        if ('dbContext' in this.CreateOptions)
            this.dbContext = this.CreateOptions.dbContext;

        this.Identity = new IdentityProvider({ id: 0, name: 'New Scenario' });

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._OnLoadComplete = undefined;
        this.LoadProgressProvider = new ProgressProvider('Loading', this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

        this.drWB_ScenarioPlan = undefined;

        this.IHaveSecurity_init();
        this.IScenarioPlan_init();
        this.CustomerProducts_init();
        this.Period_init();
        this.ICubeSourceScenario_init();
        this.IHaveSimulationFunctions_Init();
        this.SimulationInputs_init()
        this.IHaveScnPlanCalculator_init()
        this.IEventType_init()
        this.Settings_init()

    }


    get WB_ScenarioPlan(): WB_ScenarioPlanRow {
        return this.drWB_ScenarioPlan;
    }

    //<editor-fold desc = "IBusinessObject operations">

    async LoadNew(options?: IBusinessObjectCreateLoadOptions): Promise<IBusinessObject> {
        const self = this;

        self.LoadProgressProvider.start("Creating Scenario");
        const rv = self._OnLoadComplete = (async () => {

            self.LoadOptions = options || {};
            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if (_.isEmpty(self.dbContext)) {
                const sError = "Unable to determine dbContext for new Scenario.";
                self._OnLoadComplete = undefined;
                self.LoadProgressProvider.exception(sError);

                return self;
            }
            try {
                // Create record using dbContext
                const planRow: WB_ScenarioPlanRow = <WB_ScenarioPlanRow>await self.dbContext.createRecordWithKey(esWB_ScnPlan)
                planRow.setDefaults()
                planRow.cif.PLAN_NAME = self.LoadOptions.sName
                planRow.cif.TEMPLATE_IND = (self.LoadOptions.templateInd)?"1":"0"
                planRow.cif.WB_MDSET_ID = self.LoadOptions.wbMasterDataSetId || 0
                planRow.cif.WB_SALESORG_ID = self.LoadOptions.wbSalesOrgId || 0
                planRow.cif.WB_PUBLISHED_MODEL_ID = self.LoadOptions.wbPublishedModelId || 0
                planRow.cif.WB_CUSTH_ID = self.LoadOptions.wbCustHId || 0
                planRow.cif.WB_PRDH_ID = self.LoadOptions.wbPrdHId || 0
                planRow.cif.WB_PERIODH_ID = self.LoadOptions.wbPeriodHId || 0
                planRow.cif.VOLUME_TYPE = self.LoadOptions.sVolumeType || ''
                await planRow.loadRelations([esWB_Published_Model, esWB_Customer_Hierarchy, esWB_Product_Hierarchy, esWB_Period_Hierarchy, esWB_MasterData_Set, esWB_SalesOrg])
                if(!_.isEmpty(planRow.WB_PublishedModelRow)) {
                    await planRow.WB_PublishedModelRow.loadRelations([esWB_Model])
                    planRow.StartDt = planRow.WB_PublishedModelRow.EffectiveStartDt
                    planRow.EndDt = DateUtils.addDays(planRow.StartDt,6)

                    let predictors = await ModelUtils.getModelPredictorList(planRow.WB_PublishedModelRow.cif.WB_MODEL_ID, {})
                    let driverPerspectiveOptions = planRow.PerspectiveOptions
                    let driverTableOptions = planRow.TableOptions
                    driverPerspectiveOptions.MetricIds = _.map(predictors, (p) => `Predictor_${p.cif.MODEL_PREDICTOR_ID}`)
                    driverTableOptions.MetricPlacement = DimensionPlacement.OnRows
                    planRow.PerspectiveOptions = driverPerspectiveOptions
                    planRow.TableOptions = driverTableOptions
                }

                self.drWB_ScenarioPlan = planRow;
                self.dbContext.add(esWB_ScnPlan, planRow)
                self.Identity.setAll(self.WB_ScenarioPlan.cif.WB_SCNPLAN_ID, self.WB_ScenarioPlan.cif.PLAN_ID, self.WB_ScenarioPlan.cif.PLAN_NAME);
                self.Identity.listenToRecordUpdates(self.WB_ScenarioPlan, "WB_SCNPLAN_ID", "PLAN_ID", "PLAN_NAME");
                self.Identity.enableRecordWriteBack(self.WB_ScenarioPlan, "PLAN_ID", "PLAN_NAME");
                self.Identity.mdset = self.WB_ScenarioPlan.cif.WB_MDSET_ID;
                self.Identity.salesOrg = self.WB_ScenarioPlan.cif.WB_SALESORG_ID;
                self.Identity.createdBy = self.WB_ScenarioPlan.cif.WB_AUTHUSR_ID_CREATEDBY

                self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");

                await self._AfterBoLoadCompleteInternal()
                self._bIsLoaded = true;
                self._OnLoadComplete = undefined;
                self.LoadProgressProvider.finish();
                await self.OnICubeSourceScenarioLoaded
                return self;
            } catch (err) {
                self.LoadProgressProvider.exception(err)
                return self
            }

        })();

        return rv;
    }

    async Load(anId: number , options?: object): Promise<IBusinessObject> {
        const self = this;

        let recordResolver: ESRecordResolver
        let recordResolverLoadPromise: Promise<void>

        self.LoadProgressProvider.start("Loading (" + anId + ")");

        const rv = self._OnLoadComplete = (async () => {

            self.LoadProgressProvider.start("Loading (" + self.Identity.id_ui + ")");

            if (self.bIsLoaded) {
                self.LoadProgressProvider.exception("Scenario Plan already loaded.");
                self._OnLoadComplete = undefined;
                return self;
            }

            self.LoadOptions = options || {};

            try {
                if ('dbContext' in self.LoadOptions)
                    self.dbContext = self.LoadOptions.dbContext;
                else if (_.isEmpty(self.dbContext)) {
                    self.dbContext = new PAdbContext({});
                }

                if (_.isEmpty(self.dbContext)) {
                    self.LoadProgressProvider.exception("Unable to determine dbContext for Scenario Plan.");
                    return self;
                }


                if ('RecordResolver' in self.LoadOptions) {
                    recordResolver = (<any>self.LoadOptions).RecordResolver
                    recordResolverLoadPromise = ASync.resolve()
                } else {
                    recordResolver = ScenarioPlanBO.createRecordResolver({ dbContext: self.dbContext })
                    recordResolverLoadPromise = ScenarioPlanBO.setupRecordResolver(recordResolver, [anId])
                }


                await recordResolverLoadPromise
                const aPlanRow: any = recordResolver.get(esWB_ScnPlan, anId)

                if (_.isEmpty(aPlanRow)) {
                    throw "Scenario Plan not found";
                }

                self.drWB_ScenarioPlan = aPlanRow;
                self.Identity.setAll(self.WB_ScenarioPlan.cif.WB_SCNPLAN_ID, self.WB_ScenarioPlan.cif.PLAN_ID, self.WB_ScenarioPlan.cif.PLAN_NAME)
                self.Identity.listenToRecordUpdates(self.WB_ScenarioPlan, 'WB_SCNPLAN_ID', 'PLAN_ID', 'PLAN_NAME')
                self.Identity.enableRecordWriteBack(self.WB_ScenarioPlan, "PLAN_ID", "PLAN_NAME")
                self.Identity.mdset = self.WB_ScenarioPlan.cif.WB_MDSET_ID;
                self.Identity.salesOrg = self.WB_ScenarioPlan.cif.WB_SALESORG_ID;
                self.Identity.createdBy = self.WB_ScenarioPlan.cif.WB_AUTHUSR_ID_CREATEDBY

                self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");

                await self._AfterBoLoadCompleteInternal()
                self._bIsLoaded = true;
                self._OnLoadComplete = undefined;
                self.LoadProgressProvider.finish();
                await self.OnICubeSourceScenarioLoaded
                return self;
            } catch
                (err) {
                self._OnLoadComplete = undefined;
                self.LoadProgressProvider.exception(err);
                throw err
            }

        })();

        return rv;
    }

    Reload(opts?: any): Promise<IBusinessObject> {
        const self = this

        return new Promise<IBusinessObject>((resolve, error) => {

            if (!self.bIsLoaded) {
                error("Reload: Scenario BO not loaded")
                return
            }

            const id = self.WB_ScenarioPlan.cif.WB_SCNPLAN_ID

            self.dbContext.purgeCache(esWB_ScnPlan, self.WB_ScenarioPlan, {})
                .then((ignore) => {
                    self._bIsLoaded = false
                    self.ICubeSource_beforeReload()
                    self._periodsOnLoadComplete = undefined
                    self._OnLoadComplete = undefined
                    self.IHaveSecurity_beforeReload()

                    return self.Load(id, { dbContext: self.dbContext })
                })
                .then((aBO) => {
                    if (!aBO.bIsLoaded) {
                        console.log("Unable to Load BO in Reload function")
                    }
                    // Fire any existing Behavior Subjects that could have changed state
                    self.OnProductsChanged.next(self)
                    resolve(self)
                })
                .catch((err) => {
                    error(err)
                })
        })

    }

    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }


    async Validate(options?: any): Promise<IBusinessObject> {
        const self = this;

        self.ValidateMessageProvider.clearMessages();
        self.ValidateProgressProvider.start("Validating " + self.WB_ScenarioPlan.cif.MDSET_NAME + "(" + self.WB_ScenarioPlan.cif.MDSET_ID + ")");

        self.ValidateOptions = options || {};
        try {
            if (_.isEmpty(self.dbContext)) {
                const sError = "Unable to determine dbContext for to Validate Scenario Plan.";
                self.ValidateProgressProvider.exception(sError);
                return self;
            }
            //await ScenarioPlanBOValidations.Validate(self)

            self._bIsValidated = (self.ValidateMessageProvider.countMessages(MessageType.Error) == 0)
            self.ValidateProgressProvider.finish();

        } catch (err) {
            self.ValidateMessageProvider.addMessage({
                code: 'Exception',
                type: MessageType.Error,
                description: JSON.stringify(err),
                title: 'Validation Exception'
            })
            self._bIsValidated = false;
            self.ValidateProgressProvider.exception(err);
        }

        return self
    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }


    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    async SaveUsing(bBatch: boolean, options?: any): Promise<IBusinessObject> {
        const self = this;

        self._bIsSaved = false
        const wbScenarioPlan = <IwbScenarioPlan>self.drWB_ScenarioPlan;
        self.SaveProgressProvider.start("Saving " + wbScenarioPlan.PLAN_NAME + "(" + wbScenarioPlan.PLAN_ID + ")");
        try {
            // Doesn't need to do anything yet
            // All the records are in the store, since they were added through find or createNewRecord.
            // -- We could search the tree if the there is any record where store isn't set.

            if (_.isEmpty(this.dbContext)) {
                const sError = "Unable to determine dbContext to Save Scenario Plan.";
                self.SaveProgressProvider.exception(sError);
                return self
            }
            self.SaveOptions = options || {};

            await self.Validate(options)
            if (self.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                self.SaveProgressProvider.finish();
                return self
            }

            let saveFunction: (esName: string, saveRecords: ESRecord[] | ESRecord, options?: any) => Promise<ESDataStore>
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext)
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext)
            }

            await saveFunction(esWB_ScnPlan, self.drWB_ScenarioPlan, {})

            const tasks: Promise<any>[] = []

            tasks.push(saveFunction(esWB_ScnPlan_EvtTypeR, self.drWB_ScenarioPlan.WB_ScenarioPlanEventTypeRows))
            tasks.push(saveFunction(esWB_ScnPlan_CustR, self.drWB_ScenarioPlan.WB_ScenarioPlanCustomerRows))
            tasks.push(saveFunction(esWB_ScnPlan_PrdR, self.drWB_ScenarioPlan.WB_ScenarioPlanProductRows))
            tasks.push(saveFunction(esWB_ScnPlan_InputR, self.drWB_ScenarioPlan.WB_ScenarioPlanInputRows))
            tasks.push(saveFunction(esWB_ScnPlan_PredictorR, self.drWB_ScenarioPlan.WB_ScenarioPlanPredictorRows))
            tasks.push(saveFunction(esWB_ScnPlan_CoeffR, self.drWB_ScenarioPlan.WB_ScenarioPlanCoefficientRows))
            tasks.push(saveFunction(esWB_Spend_Function_Relationship, self.drWB_ScenarioPlan.WB_SpendFunctionRelationshipRows))
            tasks.push(saveFunction(esWB_Spend_Function_Relationship_Scope, _.flatMap(self.drWB_ScenarioPlan.WB_SpendFunctionRelationshipRows, (a) => a.WB_SpendFunctionRelationshipScopeRows)))
            await Promise.all(tasks)


            if (bBatch) {
                self.dbContext.addBatchCompleteListener(() => {
                    self._bIsSaved = true;
                    self.OnSimulationFunctionsChanged.next({self: self, type: 'AfterSave'})
                })
            } else {
                self._bIsSaved = true;
                self.OnSimulationFunctionsChanged.next({self: self, type: 'AfterSave'})
            }
            self.SaveProgressProvider.finish();
            return self;
        } catch (err) {
            self.SaveProgressProvider.exception(err);
            return self
        }

    }

    get bIsSaved(): boolean {
        return this._bIsSaved;
    }


//Delete
    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }

    private async DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        const self = this;

        const scnPlan = <IwbScenarioPlan>self.drWB_ScenarioPlan;

        this.DeleteMessageProvider.clearMessages();
        this.DeleteProgressProvider.start("Deleting " + scnPlan.PLAN_NAME + "(" + scnPlan.PLAN_ID + ")");

        try {
            // 1. Validate if we can delete the Scenario
            //await ScenarioPlanBOValidations.ValidateDelete(self)
            if (self.DeleteMessageProvider.countMessages(MessageType.Error) > 0) {
                return self
            }

            // 2. If Valid, mark all the records for deletion.
            self.drWB_ScenarioPlan.markDeleted()

            if (bSaveNow) {
                await self.SaveUsing(false)

                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                return (self);
            } else {
                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                return self;
            }

        } catch (err) {
            self.DeleteProgressProvider.exception(err)
            return self
        }
    }

    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }

    private async _AfterBoLoadCompleteInternal(): Promise<void> {
        const self = this;

        self.LoadProgressProvider.setProgressMessage('ScenarioPlanBO.PostLoad', 'Processing Loaded Data');

        self.WB_ScenarioPlan.snapshotHierarchies()

        await self.IHaveSecurity_OnLoadComplete()

        const tasks: Promise<any>[] = [];
        tasks.push(self.CustomerProducts_OnLoadComplete())
        tasks.push(self.Period_OnLoadComplete())
        tasks.push(self.IHaveSimulationFunctions_onLoadComplete())
        tasks.push(self.SimulationInputs_onLoadComplete())
        tasks.push(self.IEventType_onLoadComplete())
        await Promise.all(tasks)
        await self.ICubeSource_OnLoadComplete()
        await self.IHaveScnPlanCalculator_OnLoadComplete()

        return
    }

    async Copy(options?: IScenarioPlanCopyOptions): Promise<ScenarioPlanBO> {
        const self = this

        let newScnPlan = new ScenarioPlanBO({dbContext: self.dbContext})

        await newScnPlan.LoadNew({
            dbContext: self.dbContext,
            sName: self.WB_ScenarioPlan.cif.PLAN_NAME + " - Copy",
            wbMasterDataSetId: self.WB_ScenarioPlan.cif.WB_MDSET_ID,
            wbSalesOrgId: self.WB_ScenarioPlan.cif.WB_SALESORG_ID,
            wbPublishedModelId: self.WB_ScenarioPlan.cif.WB_PUBLISHED_MODEL_ID,
            wbCustHId: self.WB_ScenarioPlan.cif.WB_CUSTH_ID,
            wbPrdHId: self.WB_ScenarioPlan.cif.WB_PRDH_ID,
            wbPeriodHId: self.WB_ScenarioPlan.cif.WB_PERIODH_ID,
        })

        if(_.isBoolean(options?.bEventMode))
            newScnPlan.WB_ScenarioPlan.cif.EVENT_MODE_IND = (options.bEventMode)?"1":"0"
        else
            newScnPlan.WB_ScenarioPlan.cif.EVENT_MODE_IND = self.WB_ScenarioPlan.cif.EVENT_MODE_IND

        if (newScnPlan.WB_ScenarioPlan.bEventMode) {
            for (let r of self.WB_ScenarioPlan.WB_ScenarioPlanEventTypeRows) {
                if (!r.isActive)
                    return
                await newScnPlan.addEventType(r.cif.WB_MODEL_EVTTYPER_ID)
            }
        }
        newScnPlan.WB_ScenarioPlan.cif.VOLUME_TYPE = self.WB_ScenarioPlan.cif.VOLUME_TYPE

        newScnPlan.CubeSource_syncPause();

        let wbCustIds: number[] = []
        if(!_.isEmpty(options?.wbCustIds))
            wbCustIds = options.wbCustIds;
        else
            wbCustIds = _.map(self.Customers, (c) => c.cif.WB_CUST_ID)

        for(let wbCustId of wbCustIds){
            await newScnPlan.addCustomer(wbCustId)
        }

        let wbPrdGrpIds: number[] = []
        if(!_.isEmpty(options?.wbPrdGrpIds))
            wbPrdGrpIds = options.wbPrdGrpIds;
        else
            wbPrdGrpIds = _.map(self.ProductGroups, (p) => p.cif.WB_PRDGRP_ID)

        for(let wbPrdGrpId of wbPrdGrpIds){
            await newScnPlan.addProductGroup(wbPrdGrpId)
        }

        if(_.isDate(options.startDt))
            newScnPlan.WB_ScenarioPlan.StartDt = options.startDt
        else
            newScnPlan.WB_ScenarioPlan.StartDt = self.WB_ScenarioPlan.StartDt

        if(_.isDate(options.endDt))
            newScnPlan.WB_ScenarioPlan.EndDt = options.endDt
        else
            newScnPlan.WB_ScenarioPlan.EndDt = self.WB_ScenarioPlan.EndDt

        await newScnPlan.Period_updatePeriods()

        // Read source predictors
        let predictors = await ModelUtils.getModelPredictorList(self.WB_ScenarioPlan.cif.WB_MODEL_ID, {})

        // Load CubeSource
        let predictorMetricIds = _.map(predictors, (a) => `Metric_${a.cif.MODEL_PREDICTOR_ID}`)
        let allData = self.CubeSource.createPerspective("LoadAll", {bEnabled: false, Dimensions: {}, MetricIds: predictorMetricIds})
        await allData.OnCubePerspectiveLoadComplete

        let dctPredictorValues: {[wbCustId: number]: {[wbPrdGrpId: number]: {[wbPeriodId: number]: {[key:string]: number}}}} = {}
        for(let aRow of self.WB_ScenarioPlan.WB_ScenarioPlanPredictorRows){
            if(!aRow.isActive)
                continue

            let wbCustId = aRow.cif.WB_CUST_ID
            let wbPrdGrpId = aRow.cif.WB_PRDGRP_ID
            let wbPeriodId = aRow.cif.WB_PERIOD_ID

            if(!(wbCustId in dctPredictorValues))
                dctPredictorValues[wbCustId] = {}
            if(!(wbPrdGrpId in dctPredictorValues[wbCustId]))
                dctPredictorValues[wbCustId][wbPrdGrpId] = {}
            if(!(wbPeriodId in dctPredictorValues[wbCustId][wbPrdGrpId]))
                dctPredictorValues[wbCustId][wbPrdGrpId][wbPeriodId] = {}

            let tgt =dctPredictorValues[wbCustId][wbPrdGrpId][wbPeriodId]
            _.forEach(predictors, (p) => {
                tgt[p.cif.MODEL_PREDICTOR_ID] = <number> aRow.get(p.cif.MODEL_PREDICTOR_ID)
            })
        }

        // Create Predictor rows in Copy
        let addRows: WB_ScenarioPlanPredictorRow[] = []

        for(let aCustomerRow of newScnPlan.Customers){
            for(let aProductGroupRow of newScnPlan.ProductGroups){
                for(let aPeriodRow of newScnPlan.Periods){
                    const newRecord: WB_ScenarioPlanPredictorRow = <any>await newScnPlan.dbContext.createRecordWithKey(esWB_ScnPlan_PredictorR)
                    newRecord.setDefaults()
                    newRecord.cif.WB_SCNPLAN_ID = newScnPlan.WB_ScenarioPlan.cif.WB_SCNPLAN_ID
                    newRecord.cif.WB_CUST_ID = aCustomerRow.cif.WB_CUST_ID
                    newRecord.WB_CustomerRow = aCustomerRow
                    newRecord.cif.WB_PRDGRP_ID = aProductGroupRow.cif.WB_PRDGRP_ID
                    newRecord.WB_ProductGroupRow = aProductGroupRow
                    newRecord.cif.WB_PERIOD_ID = aPeriodRow.cif.WB_PERIOD_ID
                    newRecord.WB_PeriodRow = aPeriodRow
                    newScnPlan.dbContext.add(esWB_ScnPlan_PredictorR, newRecord)
                    addRows.push(newRecord)
                }
            }
        }
        // Copy in Predictor Values
        for(let aNewRow of addRows){
            let wbCustId = aNewRow.cif.WB_CUST_ID
            let wbPrdGrpId = aNewRow.cif.WB_PRDGRP_ID
            let wbPeriodId = aNewRow.cif.WB_PERIOD_ID
            let src = dctPredictorValues?.[wbCustId]?.[wbPrdGrpId]?.[wbPeriodId]
            if(_.isEmpty(src))
                continue
            _.forEach(predictors, (p) => {
                // @ts-expect-error "Dynamic Column"
                aNewRow[p.cif.MODEL_PREDICTOR_ID] = src[p.cif.MODEL_PREDICTOR_ID] || 0
            })
        }

        let simInputs = self.arrInputs
        let dctInputValues: {[wbCustId: number]: {[wbPrdGrpId: number]: {[wbPeriodId: number]: {[key:string]: number}}}} = {}
        for(let aRow of self.WB_ScenarioPlan.WB_ScenarioPlanInputRows){
            if(!aRow.isActive)
                continue
            let wbCustId = aRow.cif.WB_CUST_ID
            let wbPrdGrpId = aRow.cif.WB_PRDGRP_ID
            let wbPeriodId = aRow.cif.WB_PERIOD_ID

            if(!(wbCustId in dctInputValues))
                dctInputValues[wbCustId] = {}
            if(!(wbPrdGrpId in dctInputValues[wbCustId]))
                dctInputValues[wbCustId][wbPrdGrpId] = {}
            if(!(wbPeriodId in dctInputValues[wbCustId][wbPrdGrpId]))
                dctInputValues[wbCustId][wbPrdGrpId][wbPeriodId] = {}

            let tgt =dctInputValues[wbCustId][wbPrdGrpId][wbPeriodId]
            _.forEach(simInputs, (si) => {
                tgt[si.cif.SIMULATION_INPUT_ID] = <number> aRow.get(si.cif.SIMULATION_INPUT_ID)
            })
        }

        //--
        // Create Input rows in Copy
        let addInputRows: WB_ScenarioPlanInputRow[] = []

        for(let aCustomerRow of newScnPlan.Customers){
            for(let aProductGroupRow of newScnPlan.ProductGroups){
                for(let aPeriodRow of newScnPlan.Periods){
                    const newRecord: WB_ScenarioPlanInputRow = <any>await newScnPlan.dbContext.createRecordWithKey(esWB_ScnPlan_InputR)
                    newRecord.setDefaults()
                    newRecord.cif.WB_SCNPLAN_ID = newScnPlan.WB_ScenarioPlan.cif.WB_SCNPLAN_ID
                    newRecord.cif.WB_CUST_ID = aCustomerRow.cif.WB_CUST_ID
                    newRecord.WB_CustomerRow = aCustomerRow
                    newRecord.cif.WB_PRDGRP_ID = aProductGroupRow.cif.WB_PRDGRP_ID
                    newRecord.WB_ProductGroupRow = aProductGroupRow
                    newRecord.cif.WB_PERIOD_ID = aPeriodRow.cif.WB_PERIOD_ID
                    newRecord.WB_PeriodRow = aPeriodRow
                    newScnPlan.dbContext.add(esWB_ScnPlan_InputR, newRecord)
                    addInputRows.push(newRecord)
                }
            }
        }
        // Copy in Input Values
        for(let aNewRow of addInputRows){
            let wbCustId = aNewRow.cif.WB_CUST_ID
            let wbPrdGrpId = aNewRow.cif.WB_PRDGRP_ID
            let wbPeriodId = aNewRow.cif.WB_PERIOD_ID
            let src = dctInputValues?.[wbCustId]?.[wbPrdGrpId]?.[wbPeriodId]
            if(_.isEmpty(src))
                continue
            _.forEach(simInputs, (si) => {
                // @ts-expect-error "Dynamic Column"
                aNewRow[si.cif.SIMULATION_INPUT_ID] = src[si.cif.SIMULATION_INPUT_ID] || 0
            })
        }

        const dsPredictorDataSource: DataSourceJSData = <DataSourceJSData> newScnPlan._cubeSourceScenario.getDataSource("Predictor")
        if(!_.isEmpty(dsPredictorDataSource) && !_.isEmpty(addRows)) {
            dsPredictorDataSource.add(addRows)

            dsPredictorDataSource.setKnownKeyOptions({
                [DimensionType.Customer]: {
                    bUseKnownKeys: true,
                    KnownLeafKeys: _.map(newScnPlan.Customers, (a) => a.cif.WB_CUST_ID)
                },
                [DimensionType.Product]: {
                    bUseKnownKeys: true,
                    KnownLeafKeys: _.map(newScnPlan.ProductGroups, (a) => a.cif.WB_PRDGRP_ID)
                },
                [DimensionType.Time]: {
                    bUseKnownKeys: true,
                    KnownLeafKeys: _.map(newScnPlan.Periods, (a) => a.cif.WB_PERIOD_ID)
                }
            })
        }

        const dsInputDataSource: DataSourceJSData = <DataSourceJSData> newScnPlan._cubeSourceScenario.getDataSource("Input")
        if(!_.isEmpty(dsInputDataSource) && !_.isEmpty(addInputRows)) {
            dsInputDataSource.add(addInputRows)

            dsInputDataSource.setKnownKeyOptions({
                [DimensionType.Customer]: {
                    bUseKnownKeys: true,
                    KnownLeafKeys: _.map(newScnPlan.Customers, (a) => a.cif.WB_CUST_ID)
                },
                [DimensionType.Product]: {
                    bUseKnownKeys: true,
                    KnownLeafKeys: _.map(newScnPlan.ProductGroups, (a) => a.cif.WB_PRDGRP_ID)
                },
                [DimensionType.Time]: {
                    bUseKnownKeys: true,
                    KnownLeafKeys: _.map(newScnPlan.Periods, (a) => a.cif.WB_PERIOD_ID)
                }
            })
        }


        await newScnPlan.validateAndLockConfiguration()

        newScnPlan.CubeSource_syncResume();

        return newScnPlan
    }



    //</editor-fold>

    //<editor-fold desc = "IHaveSecurity operations">

    private _PolicyCollection: IPolicyCollection;
    private _bIHaveSecurityLoaded: boolean;
    private _OnIHaveSecurityLoaded: Promise<IHaveSecurity>

    //private _Lock: ILock

    IHaveSecurity_init() {
        this._PolicyCollection = new PolicyCollection()
        this._bIHaveSecurityLoaded = false
        this._OnIHaveSecurityLoaded = undefined
        //this._Lock = undefined
    }

    IHaveSecurity_beforeReload() {
        this._bIHaveSecurityLoaded = false
        this._OnIHaveSecurityLoaded = undefined
    }

    IHaveSecurity_OnLoadComplete(): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            self.OnIHaveSecurityLoaded
                .then((ignore) => {
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    get OnIHaveSecurityLoaded(): Promise<IHaveSecurity> {
        const self = this

        if (this.bIHaveSecurityLoaded) {
            return ASync.resolve(this)
        }

        if (this._OnIHaveSecurityLoaded) {
            return this._OnIHaveSecurityLoaded
        }

        let aHasRolePolicy: PolicyHasRole;
        this._OnIHaveSecurityLoaded = (async () => {
            const aBOis = new PolicyBOis(["Super_User", "Application_User"], []);
            self._PolicyCollection.addPolicy("BOis", aBOis);
            aHasRolePolicy = new PolicyHasRole();
            await aHasRolePolicy.OnLoadComplete;
            self._PolicyCollection.addPolicy("HasRole", aHasRolePolicy);
            this._bIHaveSecurityLoaded = true;
            return self;
        })();

        return this._OnIHaveSecurityLoaded
    }

    get PolicyCollection(): IPolicyCollection {
        return this._PolicyCollection
    }

    get bIHaveSecurityLoaded(): boolean {
        return this._bIHaveSecurityLoaded
    }


//</editor-fold>

    //<editor-fold desc = "BO Changes operation">

    Changes(options?: IBusinessObjectChangesOptions): IBusinessObjectChanges {
        const opts = options || {}
        opts.dctIncludeBelongsToNamedRelations = opts.dctIncludeBelongsToNamedRelations || {}
        opts.dctExcludeFields = opts.dctExcludeFields || {}
        opts.dctIgnoreChanges = opts.dctIgnoreChanges || {}

        // Set any BO Specific change settings
        opts.dctExcludeFields[esWB_ScnPlan] = ['TABLE_OPTIONS','PERSPECTIVE_OPTIONS',
                                               'METRIC_TABLE_OPTIONS','METRIC_PERSPECTIVE_OPTIONS',
                                               'FINANCIAL_TABLE_OPTIONS', 'FINANCIAL_PERSPECTIVE_OPTIONS']
        return DefaultChanges(this, this.WB_ScenarioPlan, opts)
    }


    //</editor-fold>

    //<editor-fold desc = "Add Remove Customer, Product operations">

    private _bHasProductGroups: boolean
    private _bHasProducts: boolean
    private _allCustomers: WB_CustomerRow[]
    private _allProductGroups: WB_ProductGroupRow[]
    private _allProducts: WB_FinishedProductRow[]
    private _subModels: ICoefficientSetSubModel[]
    private _onCustomersChanged: BehaviorSubject<ScenarioPlanBO>
    private _onProductsChanged: BehaviorSubject<ScenarioPlanBO>
    private custEntitySource: IEntitySource
    private prdEntitySource: IEntitySource

    private CustomerProducts_init() {
        this._bHasProductGroups = false
        this._bHasProducts = false
        this._allCustomers = []
        this._allProductGroups = []
        this._allProducts = []
        this._onCustomersChanged = new BehaviorSubject<ScenarioPlanBO>(undefined)
        this._onProductsChanged = new BehaviorSubject<ScenarioPlanBO>(undefined)
        this._subModels = []
    }

    private async CustomerProducts_OnLoadComplete(): Promise<void> {
        const self = this

        //
        if (_.isEmpty(this.WB_ScenarioPlan?.WB_PublishedModelRow))
            return
        const prdEntity = await EntityTypeUtils.getEntityTypeRow(this.WB_ScenarioPlan.WB_PublishedModelRow.cif.WB_ENTITY_ID_PRODUCT)

        if (_.isEmpty(prdEntity))
            return

        this._bHasProducts = (prdEntity.cif.ENTITY_ID in { FinishedProduct: 0, ConsumerProduct: 1 })
        this._bHasProductGroups = !this._bHasProducts

        const wbCoefSetId = this.WB_ScenarioPlan.WB_PublishedModelRow?.cif?.WB_MODEL_COEFF_SET_ID

        const a = await CoefficientSetUtils.getCoefficientSetMasterData(wbCoefSetId, this.dbContext, true)
        this._allCustomers = a.Customers || []
        this._allProducts = a.Products || []
        this._allProductGroups = a.ProductGroups || []
        this._subModels = a.SubModels

        this.custEntitySource = {
            get Entities() {
                return self.AllCustomers
            },
            get Selected() {
                return self.Customers
            },
            keyFields: {
                id: 'WB_CUST_ID',
                id_ui: 'CUSTOMER_ID',
                name: 'CUSTOMER_NAME'
            },
            onChange: this.OnCustomersChanged,
            addSelection(id: number): Promise<void> {
                return <any>self.addCustomer(id)
            },
            removeSelection(id: number): Promise<void> {
                return self.removeCustomer(id)
            }

        }

        if (this._bHasProducts) {
            this.prdEntitySource = {
                get Entities() {
                    return self.AllProducts
                },
                get Selected() {
                    return self.Products
                },
                keyFields: {
                    id: 'WB_PROD_ID',
                    id_ui: 'PRODUCT_ID',
                    name: 'PRODUCT_NAME'
                },
                onChange: this.OnProductsChanged,
                addSelection(id: number): Promise<void> {
                    return <any>self.addProduct(id)
                },
                removeSelection(id: number): Promise<void> {
                    return self.removeProduct(id)
                }
            }
        }

        if (this._bHasProductGroups) {
            this.prdEntitySource = {
                get Entities() {
                    return self.AllProductGroups
                },
                get Selected() {
                    return self.ProductGroups
                },
                keyFields: {
                    id: 'WB_PRDGRP_ID',
                    id_ui: 'PRODUCT_GROUP_ID',
                    name: 'PRODUCT_GROUP_NAME'
                },
                onChange: this.OnProductsChanged,
                addSelection(id: number): Promise<void> {
                    return <any>self.addProductGroup(id)
                },
                removeSelection(id: number): Promise<void> {
                    return self.removeProductGroup(id)
                }
            }
        }

    }

    get OnCustomersChanged(): BehaviorSubject<ScenarioPlanBO> {
        return this._onCustomersChanged
    }

    get OnProductsChanged(): BehaviorSubject<ScenarioPlanBO> {
        return this._onProductsChanged
    }

    get AllCustomers(): WB_CustomerRow[] {
        return this._allCustomers
    }

    get Customers(): WB_CustomerRow[] {
        return _.map(_.filter(this.WB_ScenarioPlan.WB_ScenarioPlanCustomerRows, (a) => {
                return a.isActive && !_.isEmpty(a.WB_CustomerRow)
            }),
            (b) => b.WB_CustomerRow)
    }

    get AllProducts(): WB_FinishedProductRow[] {
        return this._allProducts
    }

    get Products(): WB_FinishedProductRow[] {
        return _.map(_.filter(this.WB_ScenarioPlan.WB_ScenarioPlanProductRows, (a) => {
                return a.isActive && !_.isEmpty(a.WB_ProductRow) && (a.cif.WB_PROD_ID > 0)
            }),
            (b) => b.WB_ProductRow)
    }

    get AllProductGroups(): WB_ProductGroupRow[] {
        return this._allProductGroups
    }

    get ProductGroups(): WB_ProductGroupRow[] {
        return _.map(_.filter(this.WB_ScenarioPlan.WB_ScenarioPlanProductRows, (a) => {
                return a.isActive && !_.isEmpty(a.WB_ProductGroupRow) && (a.cif.WB_PRDGRP_ID > 0)
            }),
            (b) => b.WB_ProductGroupRow)
    }

    get CustomerEntitySource(): IEntitySource {
        return this.custEntitySource
    }

    get ProductEntitySource(): IEntitySource {
        return this.prdEntitySource
    }

    async addCustomer(wbCustId: number): Promise<WB_ScenarioPlanCustomerRow> {
        const self = this;
        //--
        for (const a of this.WB_ScenarioPlan.WB_ScenarioPlanCustomerRows) {
            if (!a.isActive)
                continue;
            if (a.cif.WB_CUST_ID == wbCustId)
                return a;
        }

        const cust = <WB_CustomerRow>await self.dbContext.find(esWB_Customer, wbCustId);
        if (_.isEmpty(cust))
            return undefined;

        const newRow = <WB_ScenarioPlanCustomerRow>await self.dbContext.createRecordWithKey(esWB_ScnPlan_CustR);
        newRow.cif.WB_SCNPLAN_ID = self.WB_ScenarioPlan.cif.WB_SCNPLAN_ID;
        newRow.WB_ScenarioPlanRow = self.WB_ScenarioPlan;
        newRow.cif.WB_CUST_ID = wbCustId;
        newRow.WB_CustomerRow = cust;
        self.dbContext.add(esWB_ScnPlan_CustR, newRow)
        self.OnCustomersChanged.next(self)
        return newRow;
    }

    async removeCustomer(wbCustId: number): Promise<void> {
        const self = this;
        //--
        for (const a of this.WB_ScenarioPlan.WB_ScenarioPlanCustomerRows) {
            if (!a.isActive)
                continue;
            if (a.cif.WB_CUST_ID == wbCustId)
                a.markDeleted();
        }
        self.OnCustomersChanged.next(self)
    }

    async addProductGroup(wbPrdGrpId: number): Promise<WB_ScenarioPlanProductRow> {
        const self = this;
        //--
        for (const a of this.WB_ScenarioPlan.WB_ScenarioPlanProductRows) {
            if (!a.isActive)
                continue;
            if (a.cif.WB_PRDGRP_ID == wbPrdGrpId)
                return a;
        }

        const pg = <WB_ProductGroupRow>await self.dbContext.find(esWB_Product_Group, wbPrdGrpId);
        if (_.isEmpty(pg))
            return undefined;

        const newRow = <WB_ScenarioPlanProductRow>await self.dbContext.createRecordWithKey(esWB_ScnPlan_PrdR);
        newRow.cif.WB_SCNPLAN_ID = self.WB_ScenarioPlan.cif.WB_SCNPLAN_ID;
        newRow.WB_ScenarioPlanRow = self.WB_ScenarioPlan;
        newRow.cif.WB_PRDGRP_ID = wbPrdGrpId;
        newRow.WB_ProductGroupRow = pg;
        self.dbContext.add(esWB_ScnPlan_PrdR, newRow)
        self.OnProductsChanged.next(self)

        return newRow;
    }

    async removeProductGroup(wbPrdGrpId: number): Promise<void> {
        const self = this;
        //--
        if (!(wbPrdGrpId > 0))
            return

        for (const a of this.WB_ScenarioPlan.WB_ScenarioPlanProductRows) {
            if (!a.isActive)
                continue;
            if (a.cif.WB_PRDGRP_ID == wbPrdGrpId)
                a.markDeleted();
        }

        // Cascade delete to child Predictor (Drivers) and Input (Calculated Metrics) rows for the removed PPG
        _.forEach(self.WB_ScenarioPlan.WB_ScenarioPlanPredictorRows, (r) => {
            if (r.isActive && r.cif.WB_PRDGRP_ID == wbPrdGrpId) r.markDeleted();
        });
        _.forEach(self.WB_ScenarioPlan.WB_ScenarioPlanInputRows, (r) => {
            if (r.isActive && r.cif.WB_PRDGRP_ID == wbPrdGrpId) r.markDeleted();
        });

        self.OnProductsChanged.next(self)

    }

    async addProduct(wbProdId: number): Promise<WB_ScenarioPlanProductRow> {
        const self = this;
        //--
        //--
        for (const a of this.WB_ScenarioPlan.WB_ScenarioPlanProductRows) {
            if (!a.isActive)
                continue;
            if (a.cif.WB_PROD_ID == wbProdId)
                return a;
        }

        const prd = <WB_FinishedProductRow>await self.dbContext.find(esWB_Finished_Product, wbProdId);
        if (_.isEmpty(prd))
            return undefined;

        const newRow = <WB_ScenarioPlanProductRow>await self.dbContext.createRecordWithKey(esWB_ScnPlan_PrdR);
        newRow.cif.WB_SCNPLAN_ID = self.WB_ScenarioPlan.cif.WB_SCNPLAN_ID;
        newRow.WB_ScenarioPlanRow = self.WB_ScenarioPlan;
        newRow.cif.WB_PROD_ID = wbProdId;
        newRow.WB_ProductRow = prd;
        self.dbContext.add(esWB_ScnPlan_PrdR, newRow)
        self.OnProductsChanged.next(self)

        return newRow;
    }

    async removeProduct(wbProdId: number): Promise<void> {
        const self = this;
        //--
        if (!(wbProdId > 0))
            return

        for (const a of this.WB_ScenarioPlan.WB_ScenarioPlanProductRows) {
            if (!a.isActive)
                continue;
            if (a.cif.WB_PROD_ID == wbProdId)
                a.markDeleted();
        }

        // Cascade delete to child Predictor (Drivers) and Input (Calculated Metrics) rows for the removed product
        _.forEach(self.WB_ScenarioPlan.WB_ScenarioPlanPredictorRows, (r) => {
            if (r.isActive && r.cif.WB_PROD_ID == wbProdId) r.markDeleted();
        });
        _.forEach(self.WB_ScenarioPlan.WB_ScenarioPlanInputRows, (r) => {
            if (r.isActive && r.cif.WB_PROD_ID == wbProdId) r.markDeleted();
        });

        self.OnProductsChanged.next(self)

    }


    //</editor-fold>

    //<editor-fold desc = "Add Remove Event Types">
    private _allEventTypes: WB_ModelEventTypeRelationshipRow[]
    private _eventTypes: WB_ModelEventTypeRelationshipRow[]
    private _onEventTypesChanged: BehaviorSubject<ScenarioPlanBO>

    private IEventType_init() {
        this._allEventTypes = []
        this._eventTypes = []
        this._onEventTypesChanged = new BehaviorSubject<ScenarioPlanBO>(undefined)
    }

    private async IEventType_onLoadComplete(): Promise<void> {
        const self = this
        let wbModelId = self.WB_ScenarioPlan?.WB_PublishedModelRow?.cif?.WB_MODEL_ID
        if(wbModelId > 0){
            self._allEventTypes = <WB_ModelEventTypeRelationshipRow[]> await self.dbContext.findAll(esWB_Model_Event_Type_Relationship, {where: {
                WB_MODEL_ID: wbModelId,
                DELETED_IND: {neq: '1'}
                }})
        }
    }

    get AllEventTypes(): WB_ModelEventTypeRelationshipRow[] {
        return this._allEventTypes
    }

    get EventTypes(): WB_ModelEventTypeRelationshipRow[]{
        let etr = <WB_ScenarioPlanEventTypeRow[]> _.filter(this.WB_ScenarioPlan.WB_ScenarioPlanEventTypeRows, (rd) => rd.isActive && rd.WB_ModelEventTypeRelationshipRow)
        return _.map(etr, (a) => a.WB_ModelEventTypeRelationshipRow)
    }

    get OnEventTypesChanged(): BehaviorSubject<ScenarioPlanBO> {
        return this._onEventTypesChanged
    }

    async addEventType(wbModelEvtTypeRId: number): Promise<WB_ScenarioPlanEventTypeRow> {
        const self = this

        // Check if Existing
        for(let r of self.WB_ScenarioPlan.WB_ScenarioPlanEventTypeRows){
            if(r.isActive && (r.cif.WB_MODEL_EVTTYPER_ID == wbModelEvtTypeRId))
                return r
        }

        let et = <WB_ModelEventTypeRelationshipRow> await self.dbContext.find(esWB_Model_Event_Type_Relationship, wbModelEvtTypeRId)
        if(_.isEmpty(et))
            return undefined

        let er = <WB_ScenarioPlanEventTypeRow> await self.dbContext.createRecordWithKey(esWB_ScnPlan_EvtTypeR, {})
        er.cif.WB_SCNPLAN_ID = self.WB_ScenarioPlan.cif.WB_SCNPLAN_ID
        er.WB_ScenarioPlanRow = self.WB_ScenarioPlan
        er.cif.WB_MODEL_EVTTYPER_ID = et.cif.WB_MODEL_EVTTYPER_ID
        er.WB_ModelEventTypeRelationshipRow = et
        self.dbContext.add(esWB_ScnPlan_EvtTypeR, er)
        self.OnEventTypesChanged.next(self)

        return er
    }

    async removeEventType(wbModelEvtTypeRId: number): Promise<void> {
        const self = this

        for(let r of self.WB_ScenarioPlan.WB_ScenarioPlanEventTypeRows){
            if(r.isActive && (r.cif.WB_MODEL_EVTTYPER_ID == wbModelEvtTypeRId))
                r.markDeleted()
        }

        self.OnEventTypesChanged.next(self)
    }

    //</editor-fold>

    //<editor-fold desc = "Period operations">

    private _Periods: WB_PeriodRow[]
    private _allPeriods: WB_PeriodRow[]
    private _onPeriodsChanged: BehaviorSubject<ScenarioPlanBO>
    private _wbPeriodHId_Loaded: number
    private _lock: AsyncLock
    private _periodsOnLoadComplete: Promise<void>

    private Period_init() {
        //--

        this._Periods = []
        this._allPeriods = []
        this._onPeriodsChanged = new BehaviorSubject(undefined)
        this._wbPeriodHId_Loaded = 0
        this._lock = new AsyncLock()
        this._periodsOnLoadComplete = undefined

    }

    private async Period_OnLoadComplete(): Promise<void> {
        const self = this;

        if (_.isUndefined(self._periodsOnLoadComplete))
            self._periodsOnLoadComplete = this.Period_updatePeriods();

        return await self._periodsOnLoadComplete;
    }

    private async Period_updatePeriods(): Promise<void> {
        const self = this

        await self._lock.acquire("sync", async (done) => {
            const wbPeriodHId = self.WB_ScenarioPlan.cif.WB_PERIODH_ID
            let startDt = self.WB_ScenarioPlan.StartDt
            let endDt = self.WB_ScenarioPlan.EndDt;
            const wbEntityIdPeriod = self.WB_ScenarioPlan.WB_PublishedModelRow.cif.WB_ENTITY_ID_PERIOD;
            const PubMdlStartDt = self.WB_ScenarioPlan.WB_PublishedModelRow.EffectiveStartDt
            const PubMdlEndDt = self.WB_ScenarioPlan.WB_PublishedModelRow.EffectiveEndDt
            startDt = DateUtils.Greatest(DateUtils.Least(startDt, PubMdlEndDt), PubMdlStartDt)
            endDt = DateUtils.Greatest(DateUtils.Least(endDt, PubMdlEndDt), PubMdlStartDt)

            if (self._wbPeriodHId_Loaded != wbPeriodHId) {
                self._wbPeriodHId_Loaded = wbPeriodHId
                const vSearchSchema = PASearch.createSimpleSchema([], ["WB_PERIODH_ID", "WB_ENTITY_ID", "WB_ENTITY_ID"])
                const arrPeriodSearchRows = await PASearch.find("vUI_Period_Hierarchy_Entity_Search",
                    {
                        where: {
                            WB_PERIODH_ID: wbPeriodHId,
                            WB_ENTITY_ID: wbEntityIdPeriod
                        }
                    }, vSearchSchema, [], 0, ["WB_PERIOD_ID"])
                const arrWbPeriodIds = <number[]>_.map(arrPeriodSearchRows, (row) => row.WB_PERIOD_ID)
                let allPeriods = <WB_PeriodRow[]>await self.dbContext.findUsingCache(esWB_Period, arrWbPeriodIds)

                allPeriods = _.sortBy(allPeriods, (a) => a.cif.PERIOD_START_DT)
                this._allPeriods = allPeriods
            }

            let periods: WB_PeriodRow[] = []
            if (DateUtils.isLessThanEqual(startDt, endDt)) {
                periods = _.filter(this._allPeriods, (p) => DateUtils.RangeDatesOverlap(startDt, endDt, p.PeriodStartDt, p.PeriodEndDt))
                this._Periods = periods
            } else {
                // Don't change anything, avoid deleting stuff when dates invalid
            }

            self.OnPeriodsChanged.next(self)
            done()
        });

    }

    get Periods(): WB_PeriodRow[] {
        return this._Periods
    }

    get OnPeriodsChanged(): BehaviorSubject<ScenarioPlanBO> {
        return this._onPeriodsChanged
    }

    //</editor-fold>

    //<editor-fold desc = "IScenarioPlan operations">

    private _onScopeLockChange: BehaviorSubject<void>

    private IScenarioPlan_init() {
        //--
        this._onScopeLockChange = new BehaviorSubject<void>(undefined)

    }

    get OnScopeLockChanged(): BehaviorSubject<void> {
        return this._onScopeLockChange
    }

    get bConfigurationLocked(): boolean {
        return this.WB_ScenarioPlan.bLocked
    }


    async unlockConfiguration(): Promise<void> {
        //

        this.WB_ScenarioPlan.bLocked = false
        this._onScopeLockChange.next()
    }

    async validateAndLockConfiguration(): Promise<void> {
        // Validate selections

        //--
        await this.Period_updatePeriods()
        this.CubeSource_sync();

        this.WB_ScenarioPlan.bLocked = true
        this._onScopeLockChange.next()
    }

    //</editor-fold>

    //<editor-fold desc = "ICubeSource Scenario operations">
    private _bICubeSourceScenarioLoaded: boolean
    private _cubeSourceScenario: CubeSource
    private _qsCubeSourceScenario_sync: ExecutionSerializer
    private _syncCubeSourceSyncPaused: boolean
    private _subCubeSourceCustChange: Subscription = undefined
    private _subCubeSourcePrdChange: Subscription = undefined
    private _subCubeSourcePeriodChange: Subscription = undefined


    private ICubeSourceScenario_init() {
        this._bICubeSourceScenarioLoaded = false
        this._cubeSourceScenario = undefined
        this._syncCubeSourceSyncPaused = false
        this._qsCubeSourceScenario_sync = new ExecutionSerializer(this, this._CubeSourceDataRow_sync.bind(this),
            [{}], 250, false)

    }

    ICubeSource_beforeReload() {

        this._bICubeSourceScenarioLoaded = false

        // Reset the CubeSource Queue
        if (this._subCubeSourceCustChange) {
            this._subCubeSourceCustChange.unsubscribe()
            this._subCubeSourceCustChange = undefined
        }

        if (this._subCubeSourcePrdChange) {
            this._subCubeSourcePrdChange.unsubscribe()
            this._subCubeSourcePrdChange = undefined
        }
        if (this._subCubeSourcePeriodChange) {
            this._subCubeSourcePeriodChange.unsubscribe()
            this._subCubeSourcePeriodChange = undefined
        }
    }

    private async ICubeSource_OnLoadComplete(): Promise<void> {
        const self = this

        self._subCubeSourceCustChange = self.OnCustomersChanged.subscribe((bo) => {
            if (_.isEmpty(bo)) return
            if (self.bIsLoaded) {
                self.CubeSource_sync()
            }
        })

        self._subCubeSourcePrdChange = self.OnProductsChanged.subscribe((bo) => {
            if (_.isEmpty(bo)) return
            if (self.bIsLoaded) {
                self.CubeSource_sync()
            }
        })

        self._subCubeSourcePeriodChange = self.OnPeriodsChanged.subscribe((bo) => {
            if (_.isEmpty(bo)) return
            if (self.bIsLoaded) {
                self.CubeSource_sync()
            }
        })

    }

    get bICubeSourceScenarioLoaded(): boolean {
        return this._bICubeSourceScenarioLoaded
    }

    get OnICubeSourceScenarioLoaded(): Promise<void> {
        const self = this


        return (async () => {
            if (!self.bIsLoaded)
                await self.OnLoadComplete


            const arrKnownCstKeys = _.map(self.Customers, (a) => a.cif.WB_CUST_ID)
            const arrKnownPrdGrpKeys = _.map(self.ProductGroups, (a) => a.cif.WB_PRDGRP_ID)
            const arrKnownPeriodKeys = _.map(self.Periods, (a) => a.cif.WB_PERIOD_ID)

            const bEnableLazyLoading = false // Do not set to true

            if (bEnableLazyLoading)
                self.resetLazingLoadingFilters()

            self._cubeSourceScenario = new CubeSource({
                CubeSourceId: 'ScenarioPlan',
                Parameters: { Scenario: [self.WB_ScenarioPlan.cif.WB_SCNPLAN_ID] },
                dbContext: self.dbContext,
                DimensionPolicyOptions: {
                    CubeSource: undefined,
                    WB_ScenarioPlanRow: self.WB_ScenarioPlan,
                    EffectiveStartDt: self.WB_ScenarioPlan.StartDt,
                    EffectiveEndDt: self.WB_ScenarioPlan.EndDt
                },
                LoadOptions: {
                    Predictor: {
                        [DimensionType.Customer]: { bEnableLazyLoading: false },
                        [DimensionType.Product]: { bEnableLazyLoading: false },
                        [DimensionType.Time]: { bEnableLazyLoading: false }
                    },
                    Input: {
                        [DimensionType.Customer]: { bEnableLazyLoading: false },
                        [DimensionType.Product]: { bEnableLazyLoading: false },
                        [DimensionType.Time]: { bEnableLazyLoading: false }
                    }

                },
                KnownKeyOptions: {
                    Predictor: {
                        [DimensionType.Customer]: {
                            bUseKnownKeys: true,
                            KnownLeafKeys: arrKnownCstKeys
                        },
                        [DimensionType.Product]: {
                            bUseKnownKeys: true,
                            KnownLeafKeys: arrKnownPrdGrpKeys
                        },
                        [DimensionType.Time]: {
                            bUseKnownKeys: true,
                            KnownLeafKeys: arrKnownPeriodKeys
                        }
                    },
                    Input: {
                        [DimensionType.Customer]: {
                            bUseKnownKeys: true,
                            KnownLeafKeys: arrKnownCstKeys
                        },
                        [DimensionType.Product]: {
                            bUseKnownKeys: true,
                            KnownLeafKeys: arrKnownPrdGrpKeys
                        },
                        [DimensionType.Time]: {
                            bUseKnownKeys: true,
                            KnownLeafKeys: arrKnownPeriodKeys
                        }
                    }
                },
                MetricPolicyOptions: {
                    WB_MODEL_ID: self.WB_ScenarioPlan.WB_PublishedModelRow.cif.WB_MODEL_ID,
                    WB_ModelRow: self.WB_ScenarioPlan.WB_PublishedModelRow.WB_ModelRow,
                    SIMULATION_INPUT_IDs: arrSIMULATION_INPUT_IDs
                },
                KeyFieldPolicyOptions: {
                    KeyFieldNameProd: 'WB_PRDGRP_ID'
                },
                UOMPolicyOptions: {
                    WB_MODEL_ID: self.WB_ScenarioPlan.WB_PublishedModelRow.cif.WB_MODEL_ID
                },
                UOMConverterOptions: {},
                DataSourceOptions: {
                    Metric: {
                        RecordResolverOptions: {
                            dctExcludeHasManyNamedRelations: { [esWB_Simulation_Metrics]: [esWB_Simulation_Metrics_CBO_Set] }
                        }
                    }
                }
            })

            await self._cubeSourceScenario.OnICubeSourceLoadComplete

            self._cubeSourceScenario.setEnabled(self.PolicyCollection.BOis.Editable)

            self.defaultHRViews()

            self._bICubeSourceScenarioLoaded = true

        })();
    }

    get CubeSource(): ICubeSource {
        return this._cubeSourceScenario
    }

    CubeSource_onPrdGrpAdd(prdGrp: WB_ProductGroupRow): void {
        const self = this
        if (_.isEmpty(prdGrp))
            return

        // Notify Datasource has loaded PG
        let ds: DataSourceJSData = <DataSourceJSData>self._cubeSourceScenario.getDataSource("Predictor")
        ds.setLoadedKeys(DimensionType.Product, prdGrp.cif.WB_PRDGRP_ID)
        ds = <DataSourceJSData>self._cubeSourceScenario.getDataSource("Input")
        ds.setLoadedKeys(DimensionType.Product, prdGrp.cif.WB_PRDGRP_ID)

    }

    CubeSource_onCustAdd(cust: WB_CustomerRow): void {
        const self = this
        if (_.isEmpty(cust))
            return

        // Notify Datasource has loaded PG
        let ds: DataSourceJSData = <DataSourceJSData>self._cubeSourceScenario.getDataSource("Predictor")
        ds.setLoadedKeys(DimensionType.Customer, cust.cif.WB_CUST_ID)
        ds = <DataSourceJSData>self._cubeSourceScenario.getDataSource("Input")
        ds.setLoadedKeys(DimensionType.Customer, cust.cif.WB_CUST_ID)
    }

    CubeSource_onPeriodAdd(perd: WB_PeriodRow): void {
        const self = this
        if (_.isEmpty(perd))
            return

        // Notify Datasource has loaded PG
        let ds: DataSourceJSData = <DataSourceJSData>self._cubeSourceScenario.getDataSource("Predictor")
        ds.setLoadedKeys(DimensionType.Time, perd.cif.WB_PERIOD_ID)
        ds = <DataSourceJSData>self._cubeSourceScenario.getDataSource("Input")
        ds.setLoadedKeys(DimensionType.Time, perd.cif.WB_PERIOD_ID)
    }

    CubeSource_syncPause(): void {
        this._syncCubeSourceSyncPaused = true
    }

    CubeSource_syncResume(): void {
        this._syncCubeSourceSyncPaused = true
        this.CubeSource_sync()
    }

    CubeSource_sync(): void {

        // Debounce calls ...
        console.log("Synchronizing CubeSource: qsRun")
        this._qsCubeSourceScenario_sync.Run({})
    }

    private async _CubeSourceDataRow_sync(opts: any): Promise<void> {
        const self = this

        try {

            if (!self.bICubeSourceScenarioLoaded)
                await self.OnICubeSourceScenarioLoaded

            if (_.isEmpty(self._cubeSourceScenario))
                return

            if(self._syncCubeSourceSyncPaused)
                return

            for (const dsAlias of ["Predictor", "Input"]) {
                // Sync records to Predictors and Input DataSources,
                // Set Known Keys

                const dsDataSource: DataSourceJSData = <DataSourceJSData>self._cubeSourceScenario.getDataSource(dsAlias)
                /* Per Steve, customers and products should be all at published model level
                              const cstLoadScope = dsDataSource.getLoadStatus([DimensionType.Customer])[DimensionType.Customer]
                              const prdLoadScope = dsDataSource.getLoadStatus([DimensionType.Product])[DimensionType.Product]
                              const perdLoadScope = dsDataSource.getLoadStatus([DimensionType.Time])[DimensionType.Time]
                              */

                // Determine the Customers, Product Groups & Weeks... and create sync the combination of records..
                // Determine Cust Scope
                let arrCustomers: WB_CustomerRow[] = []
                arrCustomers = self.Customers
                //Per Steve, customers and products should be all at published model level
                /* if (cstLoadScope.bLoadAllLoaded) {
                     arrCustomers = self.Customers
                 } else {
                     // Use the intersection of the Customers and What' loaded (allows for remove cust to work)
                     const dctAllCustomers = _.keyBy(self.Customers, (a) => {
                         return a.cif.WB_CUST_ID
                     })
                     _.forEach(_.values(cstLoadScope.dctLeafIdLoadedById), (wbCustId) => {
                         if (wbCustId in dctAllCustomers) {
                             arrCustomers.push(dctAllCustomers[wbCustId])
                         }
                     })
                 }

                 */
                const dctCustomers = _.keyBy(arrCustomers, (aCst) => aCst.cif.WB_CUST_ID)

                // Determine PG Scope
                let arrProductGroups: WB_ProductGroupRow[] = []
                arrProductGroups = self.ProductGroups
                /*
                if (prdLoadScope.bLoadAllLoaded) {
                    arrProductGroups = self.ProductGroups
                } else {
                    // Use the intersection of the Product Groups and What' loaded (allows for remove pg to work)
                    const dctAllProductGroups = _.keyBy(self.ProductGroups, (a) => {
                        return a.cif.WB_PRDGRP_ID
                    })
                    _.forEach(_.values(prdLoadScope.dctLeafIdLoadedById), (wbPrdGrpId) => {
                        if (wbPrdGrpId in dctAllProductGroups) {
                            arrProductGroups.push(dctAllProductGroups[wbPrdGrpId])
                        }
                    })
                 */
                const dctProductGroups = _.keyBy(arrProductGroups, (aPG) => aPG.cif.WB_PRDGRP_ID)

                // Determine Period Scope
                const arrPeriods: WB_PeriodRow[] = self.Periods
                const dctPeriods: {
                    [id: number]: WB_PeriodRow
                } = _.keyBy(arrPeriods, (aPrd: WB_PeriodRow) => aPrd.cif.WB_PERIOD_ID)


                const dctMetricsRow: { [id: string]: WB_ScenarioPlanPredictorRow | WB_ScenarioPlanInputRow } = {}
                // Create Dictionary... deleting duplicate rows, and rows not in scope
                const removeKeys: number[] = []
                const addRows: (WB_ScenarioPlanPredictorRow | WB_ScenarioPlanInputRow)[] = []

                const loadedRows: (WB_ScenarioPlanPredictorRow | WB_ScenarioPlanInputRow)[] = <(WB_ScenarioPlanPredictorRow | WB_ScenarioPlanInputRow)[]>dsDataSource.LoadedRows
                _.forEach(loadedRows, (aRow) => {
                    if (!aRow.isActive) {
                        removeKeys.push(aRow.Row_Id)
                        return
                    }

                    // Check if the Customer, Product Group or Period isn't in the dataset
                    if (!(aRow.cif.WB_CUST_ID in dctCustomers)) {
                        // Remove extra Customer
                        aRow.markDeleted()
                        removeKeys.push(aRow.Row_Id)
                        return
                    }

                    if (!(aRow.cif.WB_PRDGRP_ID in dctProductGroups)) {
                        // Remove extra Product Group
                        aRow.markDeleted()
                        removeKeys.push(aRow.Row_Id)
                        return
                    }

                    if (!(aRow.cif.WB_PERIOD_ID in dctPeriods)) {
                        // Remove extra Period
                        aRow.markDeleted()
                        removeKeys.push(aRow.Row_Id)
                        return
                    }

                    const logicalKey = aRow.cif.WB_CUST_ID + '-' + aRow.cif.WB_PRDGRP_ID + '-' + aRow.cif.WB_PERIOD_ID

                    if (logicalKey in dctMetricsRow) {
                        // Remove Duplicate Row
                        aRow.markDeleted()
                        removeKeys.push(aRow.Row_Id)
                        return
                    }

                    dctMetricsRow[logicalKey] = aRow

                }) // Next Row to check for Delete

                // Create Missing Rows
                // get Period Records from this dbContext..
                for (let idxCust = 0; idxCust < arrCustomers.length; idxCust++) {
                    const aCustomerRow = arrCustomers[idxCust]
                    for (let idxPG = 0; idxPG < arrProductGroups.length; idxPG++) {
                        const aProductGroupRow = arrProductGroups[idxPG]
                        for (let idxPeriod = 0; idxPeriod < arrPeriods.length; idxPeriod++) {
                            const aPeriodRow = arrPeriods[idxPeriod]

                            const logicalKey = aCustomerRow.cif.WB_CUST_ID + '-' + aProductGroupRow.cif.WB_PRDGRP_ID + '-' + aPeriodRow.cif.WB_PERIOD_ID
                            if (logicalKey in dctMetricsRow) {
                                continue
                            }

                            // Create Missing Record.. add to Dictionary.
                            switch (dsAlias) {
                                case "Predictor": {
                                    const newRecord: WB_ScenarioPlanPredictorRow = <any>await self.dbContext.createRecordWithKey(esWB_ScnPlan_PredictorR)
                                    newRecord.setDefaults()
                                    newRecord.cif.WB_SCNPLAN_ID = self.WB_ScenarioPlan.cif.WB_SCNPLAN_ID
                                    newRecord.cif.WB_CUST_ID = aCustomerRow.cif.WB_CUST_ID
                                    newRecord.WB_CustomerRow = aCustomerRow
                                    newRecord.cif.WB_PRDGRP_ID = aProductGroupRow.cif.WB_PRDGRP_ID
                                    newRecord.WB_ProductGroupRow = aProductGroupRow
                                    newRecord.cif.WB_PERIOD_ID = aPeriodRow.cif.WB_PERIOD_ID
                                    newRecord.WB_PeriodRow = aPeriodRow
                                    self.dbContext.add(esWB_ScnPlan_PredictorR, newRecord)
                                    addRows.push(newRecord)
                                }
                                    break;
                                case "Input": {
                                    const newRecord: WB_ScenarioPlanInputRow = <any>await self.dbContext.createRecordWithKey(esWB_ScnPlan_InputR)
                                    newRecord.setDefaults()
                                    newRecord.cif.WB_SCNPLAN_ID = self.WB_ScenarioPlan.cif.WB_SCNPLAN_ID
                                    newRecord.cif.WB_CUST_ID = aCustomerRow.cif.WB_CUST_ID
                                    newRecord.WB_CustomerRow = aCustomerRow
                                    newRecord.cif.WB_PRDGRP_ID = aProductGroupRow.cif.WB_PRDGRP_ID
                                    newRecord.WB_ProductGroupRow = aProductGroupRow
                                    newRecord.cif.WB_PERIOD_ID = aPeriodRow.cif.WB_PERIOD_ID
                                    newRecord.WB_PeriodRow = aPeriodRow
                                    self.dbContext.add(esWB_ScnPlan_InputR, newRecord)
                                    addRows.push(newRecord)

                                }
                                    break
                            }
                        } // Next Period
                    } // Next PG
                }

                // Remove Old, Add Missing, Set Known Keys
                if (!_.isEmpty(removeKeys))
                    dsDataSource.remove(removeKeys)
                if (!_.isEmpty(addRows))
                    dsDataSource.add(addRows)
                dsDataSource.setKnownKeyOptions({
                    [DimensionType.Customer]: {
                        bUseKnownKeys: true,
                        KnownLeafKeys: _.map(self.Customers, (a) => a.cif.WB_CUST_ID)
                    },
                    [DimensionType.Product]: {
                        bUseKnownKeys: true,
                        KnownLeafKeys: _.map(self.ProductGroups, (a) => a.cif.WB_PRDGRP_ID)
                    },
                    [DimensionType.Time]: {
                        bUseKnownKeys: true,
                        KnownLeafKeys: _.map(self.Periods, (a) => a.cif.WB_PERIOD_ID)
                    }
                })
            } //-- Repeat for Next Alias

        } catch (err) {
            console.log("Error in Sync: ", err)
            throw err
        }

    }

    private resetLazingLoadingFilters() {
        const self = this

        const perspOptions: ICubePerspectiveOptions = self.WB_ScenarioPlan.PerspectiveOptions || {
            DimensionFilters: {},
            Dimensions: {},
            MetricIds: []
        };

        if (!("DimensionFilters" in perspOptions))
            perspOptions.DimensionFilters = {};
        perspOptions.DimensionFilters[DimensionType.Product] = { FilterByNodes: [] };
        perspOptions.DimensionFilters[DimensionType.Customer] = { FilterByNodes: [] };
        self.WB_ScenarioPlan.PerspectiveOptions = perspOptions;

    }

    private defaultHRViews() {
        const self = this

        const cs = self._cubeSourceScenario


    }

    //</editor-fold>

    //<editor-fold desc = "IHaveSimulationFunctions operations">
    private _OnSimulationFunctionsChanged: BehaviorSubject<{ self: ScenarioPlanBO; type: string; change?: any }>;
    private _OnSimulationFunctionScopesChanged: BehaviorSubject<{ self: ScenarioPlanBO; type: string; change?: any }>;
    private _allSpendFunctions: WB_SpendFunctionRow[]

    private IHaveSimulationFunctions_Init(): void {
        this._allSpendFunctions = []
        this._OnSimulationFunctionsChanged = new BehaviorSubject<{ self: ScenarioPlanBO; type: string; change?: any }>({
            self: undefined,
            type: ""
        });
        this._OnSimulationFunctionScopesChanged = new BehaviorSubject<{
            self: ScenarioPlanBO;
            type: string;
            change?: any;
        }>({
            self: undefined,
            type: ""
        });
    }

    private async IHaveSimulationFunctions_onLoadComplete(): Promise<void> {
        const wbModelId = this.WB_ScenarioPlan.WB_PublishedModelRow.cif.WB_MODEL_ID


        this._allSpendFunctions = await SpendFunctionUtils.getModelSpendFunctions(wbModelId, "",
            arrSIMULATION_INPUT_TYPE_IDs, {
                bSkipCache: true, dbContext: this.dbContext
            })
    }

    get SimulationFunctions(): WB_SpendFunctionRow[] {
        return this._allSpendFunctions;
    }

    get SimulationFunctionRels(): WB_SpendFunctionRelationshipRow[] {
        return _.filter(this.WB_ScenarioPlan.WB_SpendFunctionRelationshipRows, (row) => row.isActive);
    }

    async addSimulationFunction(
        wbSpendFunctionId: number,
        opts: { [id: string]: any }
    ): Promise<WB_SpendFunctionRelationshipRow> {
        const self = this;

        const functionRow = <WB_SpendFunctionRow>await self.dbContext.find(esWB_Spend_Function, wbSpendFunctionId);
        const newRow = <WB_SpendFunctionRelationshipRow>(
            await self.dbContext.createRecordWithKey(esWB_Spend_Function_Relationship)
        );
        newRow.setDefaults();
        newRow.cif.SPEND_ID = functionRow.cif.SPEND_FUNCTION_ID;
        newRow.cif.SPEND_NAME = functionRow.cif.SPEND_FUNCTION_NAME
        newRow.cif.WB_SCNPLAN_ID = self.WB_ScenarioPlan.cif.WB_SCNPLAN_ID;
        newRow.WB_ScenarioPlanRow = self.WB_ScenarioPlan;
        newRow.cif.WB_SPEND_FUNCTION_ID = wbSpendFunctionId;
        newRow.WB_SpendFunctionRow = functionRow;
        if(functionRow.cif.FUNCTION_USAGE == 'Complex')
            newRow.cif.AMOUNT_LOCATION = 'Header'
        else
            newRow.cif.AMOUNT_LOCATION = functionRow.cif.AMOUNT_LOCATION;
        newRow.cif.RATE_UOM = 'ConsumerUnit'
        newRow.cif.REDEMPTION_PCNT = 1

        self.dbContext.add(esWB_Simulation_Relationship, newRow);
        this._OnSimulationFunctionsChanged.next({ self: self, type: opts.FunctionType, change: newRow });
        return newRow;
    }

    async removeSimulationFunction(wbSpendFunctionRelationshipId: number, opts: { [id: string]: any }): Promise<void> {
        const self = this;
        _.forEach(self.WB_ScenarioPlan.WB_SpendFunctionRelationshipRows, (row) => {
            if (row.isActive && row.cif.WB_SPEND_FUNCTIONR_ID == wbSpendFunctionRelationshipId) row.markDeleted();
        });
        this._OnSimulationFunctionsChanged.next({ self: self, type: opts.FunctionType });
        return;
    }

    async addSimulationFunctionSubModels(
        SpendFunctionRelRow: WB_SpendFunctionRelationshipRow,
        wbCustomerId: number,
        wbProdId?: number,
        wbPrdGrpId?: number,
        opts?: { [id: string]: any }
    ): Promise<WB_SpendFunctionRelationshipScopeRow> {
        const self = this;
        const newRow = <WB_SpendFunctionRelationshipScopeRow>(
            await self.dbContext.createRecordWithKey(esWB_Spend_Function_Relationship_Scope)
        );
        newRow.setDefaults();
        newRow.cif.WB_SPEND_FUNCTIONR_ID = SpendFunctionRelRow.cif.WB_SPEND_FUNCTIONR_ID;
        newRow.WB_SpendFunctionRelationshipRow = SpendFunctionRelRow;

        if(wbCustomerId > 0) {
            let customerRow: WB_CustomerRow = undefined;
            if (_.isEmpty(opts?.customer)) {
                customerRow = _.first(<WB_CustomerRow[]>await self.dbContext.findUsingCache(esWB_Customer, [wbCustomerId]));
            } else {
                customerRow = opts["customer"];
            }
            newRow.cif.WB_CUST_ID = wbCustomerId;
            newRow.WB_CustomerRow = customerRow;
        }

        if(wbPrdGrpId > 0) {
            let prdgrpRow: WB_ProductGroupRow = undefined;
            if (self._bHasProductGroups) {
                if (_.isEmpty(opts) || !("prdgrp" in opts)) {
                    prdgrpRow = _.first(
                        <WB_ProductGroupRow[]>await self.dbContext.findUsingCache(esWB_Product_Group, [wbPrdGrpId])
                    );
                } else {
                    prdgrpRow = opts["prdgrp"];
                }
                newRow.cif.WB_PRDGRP_ID = wbPrdGrpId;
                newRow.WB_ProductGroupRow = prdgrpRow;
            }
        }

        let prodRow: WB_FinishedProductRow = undefined;
        if (self._bHasProducts) {
            if (_.isEmpty(opts) || !("product" in opts)) {
                prodRow = _.first(
                    <WB_FinishedProductRow[]>await self.dbContext.findUsingCache(esWB_Finished_Product, [wbProdId])
                );
            } else {
                prodRow = opts["product"];
            }

            newRow.cif.WB_PROD_ID = wbProdId;
            newRow.WB_ProductRow = prodRow;
        }

        self.dbContext.add(esWB_Spend_Function_Relationship_Scope, newRow);
        self._OnSimulationFunctionScopesChanged.next({ self: self, type: opts.FunctionType, change: newRow });
        return newRow;
    }

    async removeSimulationFunctionSubModel(
        wbSpendFunctionSubModelId: number,
        opts: { [id: string]: any }
    ): Promise<void> {
        const self = this;
        _.forEach(self.WB_ScenarioPlan.WB_SpendFunctionRelationshipRows, (row) => {
            if (!row.isActive) return;
            _.forEach(row.WB_SpendFunctionRelationshipScopeRows, (sm) => {
                if (sm.isActive && sm.cif.WB_SPEND_FUNCTIONCPR_ID == wbSpendFunctionSubModelId) {
                    sm.markDeleted();
                    return;
                }
            });
        });
        self._OnSimulationFunctionScopesChanged.next({ self: self, type: opts.FunctionType });
        return;
    }

    // Need to get list of SubModels for Scoping Function
    get SubModels(): ICoefficientSetSubModel[] {
        return this._subModels;
    }

    get OnSimulationFunctionsChanged(): BehaviorSubject<{ self: ScenarioPlanBO; type: string; change?: any }> {
        return this._OnSimulationFunctionsChanged;
    }

    get OnSimulationFunctionScopesChanged(): BehaviorSubject<{ self: ScenarioPlanBO; type: string; change?: any }> {
        return this._OnSimulationFunctionScopesChanged;
    }

    //</editor-fold>

    //<editor-fold desc = "Simulation Inputs">

    // Previously, the input set was determined by the Simulation Type, which has been removed.
    private arrInputs: WB_SimulationInputRow[];

    private SimulationInputs_init() {
        this.arrInputs = [];
    }

    private async SimulationInputs_onLoadComplete() {
        const self = this;

        self.arrInputs = <WB_SimulationInputRow[]>await self.dbContext.findAll(esWB_Simulation_Input, {
            where: {
                DELETED_IND: { neq: "1" },
                SIMULATION_INPUT_TYPE: { inq: ["COGS", "VCM", "NetListPrice", "GrossListPrice", "FundRate"] }
            }
        });
    }

    get WB_SimulationInputRows(): WB_SimulationInputRow[] {
        return this.arrInputs
    }

    //</editor-fold>

    //<editor-fold desc = "Settings">
    private onSettingsChanged: BehaviorSubject<ScenarioPlanBO>

    private Settings_init() {
        this.onSettingsChanged = new BehaviorSubject<ScenarioPlanBO>(this);
    }

    get OnSettingsChanged(): BehaviorSubject<ScenarioPlanBO> {
        return this.onSettingsChanged
    }


    //</editor-fold>


    //<editor-fold desc="IHaveSimulationCalculator operations">

    private _scnPlanCalculator: IScenarioPlanCalculator;

    private IHaveScnPlanCalculator_init() {
        this._scnPlanCalculator = new ScenarioPlanCalculator(this);
    }

    private async IHaveScnPlanCalculator_OnLoadComplete(): Promise<void> {
        const self = this;
        self._scnPlanCalculator.Register(self);
    }

    private IHaveScnPlanCalculator_BeforeReload(): void {
        // Do nothing
    }

    get ScnPlanCalculator(): IScenarioPlanCalculator {
        return this._scnPlanCalculator;
    }

    //</editor-fold>



    async ReloadMetrics(): Promise<void> {
        const self = this

        const purgeScope = { ["Customer"]: { bAll: true } }
        self._cubeSourceScenario.purgeScope(purgeScope, "Metric")
    }

    async ReloadPredictors(): Promise<void> {
        const self = this

        const purgeScope = { ["Customer"]: { bAll: true } }
        self._cubeSourceScenario.purgeScope(purgeScope, "Predictor")
    }



    //<editor-fold desc = "Load Simulation Input Execute Function" >
    async executeInputOperations(ops: ISimulationLoadInputOperations, opts?: {
        mp: IMessageProvider;
        pp: IProgressProvider
    }): Promise<void> {
        let mp = opts?.mp
        let pp = opts?.pp
        if(_.isEmpty(mp))
            mp = new MessageProvider()
        if(_.isEmpty(pp))
            pp = new ProgressProvider()

        for (let op of ops?.Operations || []){
            switch(op.LoadMethod){
                case "Constant":
                    await this.executeInputConstantOperation(op)
                    break
                case "CopyRange":
                    await this.executeInputCopyRangeOperation(op, mp)
                    break
                case "ValueAsOf":
                    await this.executeInputAsOfOperation(op, mp)
                    break
            }
        }
        this._cubeSourceScenario.OnCubeSourcePropertyChange.next({Source: this._cubeSourceScenario, PropertyName: "Perspective", PropertyValue: undefined})
    }

    private getPeriodMapping(copyRangeStart: Date): {[wbPeriodId: number]: number} {
        const self = this

        let targetPeriods = self.Periods
        if(_.isEmpty(targetPeriods))
            return {}

        let rv: {[wbPeriodId: number]: number} = {}

        let startIdx = _.findIndex(self._allPeriods, (p) => DateUtils.InRangeDates(copyRangeStart, p.PeriodStartDt, p.PeriodEndDt))
        if(startIdx == -1)
            return {}

        for(let idx = 0; idx < targetPeriods.length; idx++) {
            let sourcePeriod = self._allPeriods[idx + startIdx]
            let targetPeriod = targetPeriods[idx]
            if(_.isUndefined(sourcePeriod))
                continue
            rv[targetPeriod.cif.WB_PERIOD_ID] = sourcePeriod.cif.WB_PERIOD_ID
        }

        return rv
    }

    private getInputOperationRows(op: ISimulationLoadInputOperation): WB_ScenarioPlanInputRow[] {

        let rv: WB_ScenarioPlanInputRow[] = _.filter(this.WB_ScenarioPlan.WB_ScenarioPlanInputRows, (a) => a.isActive)
        if(!_.isEmpty(op?.wbCustIds)){
            let dct = _.keyBy(op.wbCustIds, (c) => c)
            rv = _.filter(rv, (a) => a.cif.WB_CUST_ID in dct)
        }

        if(!_.isEmpty(op?.wbPrdGrpIds)){
            let dct = _.keyBy(op.wbPrdGrpIds, (c) => c)
            rv = _.filter(rv, (a) => a.cif.WB_PRDGRP_ID in dct)
        }

        return rv
    }

    private async executeInputConstantOperation(op: ISimulationLoadInputOperation): Promise<void> {
        let rows = this.getInputOperationRows(op)
        for (let si of op.inputs) {

            let constVal = + op.dctConstants[si.cif.WB_SIMULATION_INPUT_ID]

            if(_.isUndefined(constVal) || _.isNaN(constVal))
                continue

            let fieldName = si.cif.SIMULATION_INPUT_ID

            for (let row of rows) {
                row.cif[fieldName] = constVal
            }
        }
    }

    private async executeInputAsOfOperation(op: ISimulationLoadInputOperation, mp: IMessageProvider): Promise<void>
    {
        const self = this
        const pm = self.WB_ScenarioPlan.WB_PublishedModelRow.cif;
        const wbCustIds = _.map(self.Customers, (c)=> c.cif.WB_CUST_ID)
        const wbPrdGrpIds = _.map(self.ProductGroups, (pg) => pg.cif.WB_PRDGRP_ID)


        let rows = this.getInputOperationRows(op)
        let AsOfPeriod: WB_PeriodRow
        for(let aPeriod of this._allPeriods){
            if(DateUtils.InRangeDates(op.AsOf, aPeriod.PeriodStartDt, aPeriod.PeriodEndDt)) {
                AsOfPeriod = aPeriod
                break
            }
        }

        if(_.isEmpty(AsOfPeriod)){
            ErrorMessage_restate(mp, true, "AsOfPeriod", `As of Period not found for date ${DateUtils.formatDate(op.AsOf)}`)
            return
        }
        const wbPeriods = [AsOfPeriod.cif.WB_PERIOD_ID]

        // Get Pricing Data for this Period
        let dctPolicyTerms = await SimulationPolicyUtils.PolicyTermValues_getCPG(self.WB_ScenarioPlan.cif.WB_SALESORG_ID,
            pm.cif.WB_ENTITY_ID_CUSTOMER, pm.cif.WB_ENTITY_ID_PRODUCT, pm.cif.WB_ENTITY_ID_PERIOD,
            wbCustIds, wbPrdGrpIds, wbPeriods);

        let dctScope = _.keyBy(op.inputs, (i) => i.cif.SIMULATION_INPUT_ID)

        for (const aSimInputRow of rows) {

            const wbCustId = aSimInputRow.cif.WB_CUST_ID;
            const wbPeriodId =  AsOfPeriod.cif.WB_PERIOD_ID
            let wbPrdId = 0;
            if (self._bHasProducts) wbPrdId = aSimInputRow.cif.WB_PROD_ID;
            if (self._bHasProductGroups) wbPrdId = aSimInputRow.cif.WB_PRDGRP_ID;
            let ptv = SimulationPolicyUtils.PolicyTermValues_get(dctPolicyTerms, wbCustId, wbPrdId, wbPeriodId)
            if(_.isEmpty(ptv))
                continue

            if ("GROSSLISTPRICE" in dctScope)
                aSimInputRow.cif.GROSSLISTPRICE = ptv.GrossListPrice
            if ("LISTPRICE" in dctScope)
                aSimInputRow.cif.LISTPRICE = ptv.CustomerListPrice
            if ("VCM" in dctScope)
                aSimInputRow.cif.VCM = ptv.VCM
            if ("COGS" in dctScope)
                aSimInputRow.cif.COGS = ptv.COGs
        }


    }

    private async executeInputCopyRangeOperation(op: ISimulationLoadInputOperation, mp: IMessageProvider): Promise<void>
    {
        const self = this
        const pm = self.WB_ScenarioPlan.WB_PublishedModelRow.cif;
        const wbCustIds = _.map(self.Customers, (c)=> c.cif.WB_CUST_ID)
        const wbPrdGrpIds = _.map(self.ProductGroups, (pg) => pg.cif.WB_PRDGRP_ID)


        let rows = this.getInputOperationRows(op)

        let dctPeriodMap = self.getPeriodMapping(op.CopyRangeStart)

        if(_.isEmpty(dctPeriodMap)){
            ErrorMessage_restate(mp, true, "PeriodMap", `Period Map empty for range start date ${DateUtils.formatDate(op.CopyRangeStart)}`)
            return
        }
        const wbPeriods = _.values(dctPeriodMap)

        // Get Pricing Data for this Period
        let dctPolicyTerms = await SimulationPolicyUtils.PolicyTermValues_getCPG(self.WB_ScenarioPlan.cif.WB_SALESORG_ID,
            pm.cif.WB_ENTITY_ID_CUSTOMER, pm.cif.WB_ENTITY_ID_PRODUCT, pm.cif.WB_ENTITY_ID_PERIOD,
            wbCustIds, wbPrdGrpIds, wbPeriods);

        let dctScope = _.keyBy(op.inputs, (i) => i.cif.SIMULATION_INPUT_ID)

        for (const aSimInputRow of rows) {
            const wbCustId = aSimInputRow.cif.WB_CUST_ID;
            const wbPeriodId =  dctPeriodMap[aSimInputRow.cif.WB_PERIOD_ID];
            let wbPrdId = 0;
            if (self._bHasProducts) wbPrdId = aSimInputRow.cif.WB_PROD_ID;
            if (self._bHasProductGroups) wbPrdId = aSimInputRow.cif.WB_PRDGRP_ID;
            let ptv = SimulationPolicyUtils.PolicyTermValues_get(dctPolicyTerms, wbCustId, wbPrdId, wbPeriodId)
            if(_.isEmpty(ptv))
                continue

            if ("GROSSLISTPRICE" in dctScope)
                aSimInputRow.cif.GROSSLISTPRICE = ptv.GrossListPrice
            if ("LISTPRICE" in dctScope)
                aSimInputRow.cif.LISTPRICE = ptv.CustomerListPrice
            if ("VCM" in dctScope)
                aSimInputRow.cif.VCM = ptv.VCM
            if ("COGS" in dctScope)
                aSimInputRow.cif.COGS = ptv.COGs
        }

    }

    //</editor-fold>

    //<editor-fold desc = "Load Predictor Execute Function" >

    async executePredictorOperations(ops: ISimulationLoadPredictorOperations, opts?: {
        mp: IMessageProvider;
        pp: IProgressProvider
    }): Promise<void> {
        let mp = opts?.mp
        let pp = opts?.pp
        if(_.isEmpty(mp))
            mp = new MessageProvider()
        if(_.isEmpty(pp))
            pp = new ProgressProvider()

        for (let op of ops?.Operations || []){
            switch(op.LoadMethod){
                case "Constant":
                    await this.executePredictorConstantOperation(op)
                    break
                case "CopyRange":
                    await this.executePredictorCopyRangeOperation(op, mp)
                    break
                case "ValueAsOf":
                    await this.executePredictorAsOfOperation(op, mp)
                    break
            }
        }

        this._cubeSourceScenario.OnCubeSourcePropertyChange.next({Source: this._cubeSourceScenario, PropertyName: "Perspective", PropertyValue: undefined})
    }

    private getPredictorOperationRows(op: ISimulationLoadPredictorOperation): WB_ScenarioPlanPredictorRow[] {

        let rv: WB_ScenarioPlanPredictorRow[] = _.filter(this.WB_ScenarioPlan.WB_ScenarioPlanPredictorRows, (a) => a.isActive)
        if(!_.isEmpty(op?.wbCustIds)){
            let dct = _.keyBy(op.wbCustIds, (c) => c)
            rv = _.filter(rv, (a) => a.cif.WB_CUST_ID in dct)
        }

        if(!_.isEmpty(op?.wbPrdGrpIds)){
            let dct = _.keyBy(op.wbPrdGrpIds, (c) => c)
            rv = _.filter(rv, (a) => a.cif.WB_PRDGRP_ID in dct)
        }

        return rv
    }

    private async executePredictorConstantOperation(op: ISimulationLoadPredictorOperation): Promise<void> {
        let rows = this.getPredictorOperationRows(op)
        for (let pr of op.predictors) {

            let constVal = + op.dctConstants[pr.cif.WB_MODEL_PREDICTOR_ID]

            if(_.isUndefined(constVal) || _.isNaN(constVal))
                continue

            let fieldName = pr.cif.MODEL_PREDICTOR_ID

            for (let row of rows) {
                row.cif[fieldName] = constVal
            }
        }
    }

    private async executePredictorAsOfOperation(op: ISimulationLoadPredictorOperation, mp: IMessageProvider): Promise<void>
    {
        const self = this
        const pm = self.WB_ScenarioPlan.WB_PublishedModelRow.cif;
        const wbCustIds = _.map(self.Customers, (c)=> c.cif.WB_CUST_ID)
        const wbPrdGrpIds = _.map(self.ProductGroups, (pg) => pg.cif.WB_PRDGRP_ID)


        let rows = this.getPredictorOperationRows(op)
        let AsOfPeriod: WB_PeriodRow
        for(let aPeriod of this._allPeriods){
            if(DateUtils.InRangeDates(op.AsOf, aPeriod.PeriodStartDt, aPeriod.PeriodEndDt)) {
                AsOfPeriod = aPeriod
                break
            }
        }

        if(_.isEmpty(AsOfPeriod)){
            ErrorMessage_restate(mp, true, "AsOfPeriod", `As of Period not found for date ${DateUtils.formatDate(op.AsOf)}`)
            return
        }
        const wbPeriods = [AsOfPeriod.cif.WB_PERIOD_ID]

        // Get Pricing Data for this Period
        let dctPredictorTerms = await ModelDataSetService.ModelDataSet_getCPG(self.WB_ScenarioPlan.cif.WB_SALESORG_ID,
            pm.cif.WB_MODEL_ID,
            pm.cif.WB_ENTITY_ID_CUSTOMER, pm.cif.WB_ENTITY_ID_PRODUCT, pm.cif.WB_ENTITY_ID_PERIOD,
            pm.cif.WB_CUSTH_ID_DS, pm.cif.WB_PRDH_ID_DS, pm.cif.WB_PERIODH_ID_DS,
            wbCustIds, wbPrdGrpIds, wbPeriods);


        for (const aSimPredictorRow of rows) {

            const wbCustId = aSimPredictorRow.cif.WB_CUST_ID;
            const wbPeriodId =  AsOfPeriod.cif.WB_PERIOD_ID
            let wbPrdId = 0;
            if (self._bHasProducts) wbPrdId = aSimPredictorRow.cif.WB_PROD_ID;
            if (self._bHasProductGroups) wbPrdId = aSimPredictorRow.cif.WB_PRDGRP_ID;
            let prdv = ModelDataSetService.PredictorValues_get(dctPredictorTerms, wbCustId, wbPrdId, wbPeriodId)
            if(_.isEmpty(prdv))
                continue

            for(let mp of op.predictors){
                aSimPredictorRow.cif[mp.cif.MODEL_PREDICTOR_ID] = prdv[mp.cif.MODEL_PREDICTOR_ID]
            }
        }

    }

    private async executePredictorCopyRangeOperation(op: ISimulationLoadPredictorOperation, mp: IMessageProvider): Promise<void>
    {
        const self = this
        const pm = self.WB_ScenarioPlan.WB_PublishedModelRow.cif;
        const wbCustIds = _.map(self.Customers, (c)=> c.cif.WB_CUST_ID)
        const wbPrdGrpIds = _.map(self.ProductGroups, (pg) => pg.cif.WB_PRDGRP_ID)


        let rows = this.getPredictorOperationRows(op)

        let dctPeriodMap = self.getPeriodMapping(op.CopyRangeStart)

        if(_.isEmpty(dctPeriodMap)){
            ErrorMessage_restate(mp, true, "PeriodMap", `Period Map empty for range start date ${DateUtils.formatDate(op.CopyRangeStart)}`)
            return
        }
        const wbPeriods = _.values(dctPeriodMap)

        // Get Predictor Data for this Period
        let dctPredictorTerms = await ModelDataSetService.ModelDataSet_getCPG(self.WB_ScenarioPlan.cif.WB_SALESORG_ID,
            pm.cif.WB_MODEL_ID,
            pm.cif.WB_ENTITY_ID_CUSTOMER, pm.cif.WB_ENTITY_ID_PRODUCT, pm.cif.WB_ENTITY_ID_PERIOD,
            pm.cif.WB_CUSTH_ID_DS, pm.cif.WB_PRDH_ID_DS, pm.cif.WB_PERIODH_ID_DS,
            wbCustIds, wbPrdGrpIds, wbPeriods);


        for (const aSimPredictorRow of rows) {
            const wbCustId = aSimPredictorRow.cif.WB_CUST_ID;
            const wbPeriodId =  dctPeriodMap[aSimPredictorRow.cif.WB_PERIOD_ID];
            let wbPrdId = 0;
            if (self._bHasProducts) wbPrdId = aSimPredictorRow.cif.WB_PROD_ID;
            if (self._bHasProductGroups) wbPrdId = aSimPredictorRow.cif.WB_PRDGRP_ID;
            let prdv = ModelDataSetService.PredictorValues_get(dctPredictorTerms, wbCustId, wbPrdId, wbPeriodId)
            if(_.isEmpty(prdv))
                continue

            for(let mp of op.predictors){
                aSimPredictorRow.cif[mp.cif.MODEL_PREDICTOR_ID] = prdv[mp.cif.MODEL_PREDICTOR_ID]
            }

        }

    }


    //</editor-fold>

    //<editor-fold desc = "IRecordResolver operations">

    static createRecordResolver(boLoadOptions: any): ESRecordResolver {

        const opts = boLoadOptions || {}
        let dbContext: PAdbContext

        if ('dbContext' in opts) {
            dbContext = opts.dbContext;
        } else {
            dbContext = new PAdbContext({});
        }
        const scope_options: CreateOptions = {
            standardConditions: {
                [esWB_ScnPlan]: { "DELETED_IND": { "notIn": ['1'] } },
                [esWB_ScnPlan_CustR]: { "DELETED_IND": { "notIn": ['1'] } },
                [esWB_ScnPlan_PrdR]: { "DELETED_IND": { "notIn": ['1'] } },
                [esWB_ScnPlan_CoeffR]: { "DELETED_IND": { "notIn": ['1'] } },
                [esWB_ScnPlan_PredictorR]: { "DELETED_IND": { "notIn": ['1'] } },
                [esWB_ScnPlan_InputR]: { "DELETED_IND": { "notIn": ['1'] } },
                [esWB_Simulation_Metrics]: { "DELETED_IND": { "notIn": ['1'] } }
            },
            dctIncludeBelongsToNamedRelations: {
                [esWB_Published_Model]: [esWB_Entity, esWB_Model]
            },
            dctExcludeHasManyNamedRelations: {
                [esWB_ScnPlan]: [esWB_ScnPlan_PredictorR, esWB_ScnPlan_InputR, esWB_Simulation_Metrics]
            }


        }

        const aRecResolver = new ESRecordResolver(dbContext, scope_options)

        return aRecResolver;

    }

    static setupRecordResolver(recordResolver: ESRecordResolver, ids: string[] | number[]): Promise<void> {

        return new Promise<void>((resolve, error) => {
            recordResolver.findAllWithRelationships(esWB_ScnPlan, ids).then((result) => {
                resolve()
            }).catch((err) => {
                error(err)
            })
        })
    }

    static concurrentLoadCountHint(): number {
        return 10;
    }

    //</editor-fold>

};

PAEnvironment.registerBusinessObjectClass(ScenarioPlanBO, "ScenarioPlanBO", "Scenario Plan")
